export const COMPONENT_NAME = 'EditorialText';